import React, { useEffect } from 'react';
import { CareerStyles } from './styles';
import {
  BannerCareer,
  CVBanner,
  HoldingCareer,
  NotFoundCareer,
  OpportunitiesCareer,
  VacanciesCareer,
} from '../../components';
import MetaFromApi from '../../components/metaFromApi/MetaFromApi';

export const Career = () => {
  useEffect(() => {}, []);

  return (
    <CareerStyles>
      <MetaFromApi slug="career" />
      <BannerCareer />
      <HoldingCareer />
      <OpportunitiesCareer />
      <VacanciesCareer />
      <NotFoundCareer />
    </CareerStyles>
  );
};
